import { render, staticRenderFns } from "./SaraiForm.vue?vue&type=template&id=9bcd0e86&scoped=true"
import script from "./SaraiForm.vue?vue&type=script&lang=js"
export * from "./SaraiForm.vue?vue&type=script&lang=js"
import style0 from "./SaraiForm.vue?vue&type=style&index=0&id=9bcd0e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcd0e86",
  null
  
)

export default component.exports